
/*
 * Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
 * This software is the proprietary information of Irian Software Development SRL.
 * Use is subject to license and non-disclosure terms
 */

export enum CurrencyCode {
  RON = "RON", EUR = "EUR", USD = "USD"
}
